import { render } from "./CheckVocabulary.vue?vue&type=template&id=f16b1a56"
import script from "./CheckVocabulary.vue?vue&type=script&lang=js"
export * from "./CheckVocabulary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__